import { render, staticRenderFns } from "./DocumentsPreview.vue?vue&type=template&id=2bf2be39&scoped=true"
import script from "./DocumentsPreview.vue?vue&type=script&lang=js"
export * from "./DocumentsPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf2be39",
  null
  
)

export default component.exports